'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LocationModel = require('../model/LocationModel');

var _LocationModel2 = _interopRequireDefault(_LocationModel);

var _TextControl = require('../../../lib/ui/TextControl');

var _TextControl2 = _interopRequireDefault(_TextControl);

var _UrlControl = require('../../../lib/ui/UrlControl');

var _UrlControl2 = _interopRequireDefault(_UrlControl);

var _PickerControl = require('../../../lib/ui/PickerControl');

var _PickerControl2 = _interopRequireDefault(_PickerControl);

var _PhonenumberControl = require('../../../lib/ui/PhonenumberControl');

var _PhonenumberControl2 = _interopRequireDefault(_PhonenumberControl);

var _FaxnumberControl = require('../../../lib/ui/FaxnumberControl');

var _FaxnumberControl2 = _interopRequireDefault(_FaxnumberControl);

var _EmailControl = require('../../../lib/ui/EmailControl');

var _EmailControl2 = _interopRequireDefault(_EmailControl);

var _SelectOrganisation = require('../../organisation/action/SelectOrganisation');

var _SelectOrganisation2 = _interopRequireDefault(_SelectOrganisation);

var _SelectControl = require('../../../lib/ui/SelectControl');

var _SelectControl2 = _interopRequireDefault(_SelectControl);

var _GoogleMapsButtonControl = require('../../../lib/ui/GoogleMapsButtonControl');

var _GoogleMapsButtonControl2 = _interopRequireDefault(_GoogleMapsButtonControl);

var _CountryOptions = require('../../constants/CountryOptions');

var _CountryOptions2 = _interopRequireDefault(_CountryOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LocationForm = function () {
  function LocationForm(element, args) {
    var _this = this;

    _classCallCheck(this, LocationForm);

    var fieldsetLocation = document.createElement('fieldset');
    var legendLocation = document.createElement('legend');
    legendLocation.innerHTML = 'Vestiging';
    fieldsetLocation.appendChild(legendLocation);

    this.id = args.location.values.id;
    var popup = null;

    this.organisation = new _PickerControl2.default(fieldsetLocation, { label: 'Organisatie', value: args.location.values.organisation_id,
      onchange: args.onchange,
      onselect: function onselect(item) {
        if (item.values.id) {
          window.PRIM.navigate('/organisations/' + item.values.id);
        }
      },
      onclick: function onclick() {
        var popupElement = document.getElementById('popup');
        var viewportElement = document.getElementById('viewport');

        popup = new _SelectOrganisation2.default(popupElement, {
          onok: function onok(item) {
            if (item && item.values.id) {
              _this.organisation.setValue(item.values.id, item);
            } else {
              _this.organisation.setValue(null, null);
            }

            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
            _this.organisation.onchange();
          },
          oncancel: function oncancel() {
            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
          }
        });
        viewportElement.classList.add('invisible');
        popupElement.classList.remove('invisible');
      }
    });
    this.business = new _TextControl2.default(fieldsetLocation, { label: 'Business', value: args.location.values.business, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });

    var fieldsetContact = document.createElement('fieldset');
    var legendContact = document.createElement('legend');
    legendContact.innerHTML = 'Contact gegevens';
    fieldsetContact.appendChild(legendContact);

    this.phone = new _PhonenumberControl2.default(fieldsetContact, { label: 'Telefoon', value: args.location.values.phone, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.fax = new _FaxnumberControl2.default(fieldsetContact, { label: 'Fax', value: args.location.values.fax, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.email = new _EmailControl2.default(fieldsetContact, { label: 'E-mail', value: args.location.values.email, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.website = new _UrlControl2.default(fieldsetContact, { label: 'Website', value: args.location.values.website, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });

    var fieldsetPost = document.createElement('fieldset');
    var legendPost = document.createElement('legend');
    legendPost.innerHTML = 'Postadres';
    fieldsetPost.appendChild(legendPost);

    this.postaddress = new _TextControl2.default(fieldsetPost, { label: 'Adres', value: args.location.values.postaddress, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.postzipcode = new _TextControl2.default(fieldsetPost, { label: 'Postcode', value: args.location.values.postzipcode, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.postcity = new _TextControl2.default(fieldsetPost, { label: 'Plaats', value: args.location.values.postcity, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.postregion = new _TextControl2.default(fieldsetPost, { label: 'Provincie', value: args.location.values.postregion, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.postcountry = new _SelectControl2.default(fieldsetPost, { label: 'Land', value: args.location.values.postcountry, options: _CountryOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });

    var fieldsetAddress = document.createElement('fieldset');
    var legendAddress = document.createElement('legend');
    legendAddress.innerHTML = 'Bezoekersadres';
    fieldsetAddress.appendChild(legendAddress);

    this.address = new _TextControl2.default(fieldsetAddress, { label: 'Adres', value: args.location.values.visitaddress, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.zipcode = new _TextControl2.default(fieldsetAddress, { label: 'Postcode', value: args.location.values.visitzipcode, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.city = new _TextControl2.default(fieldsetAddress, { label: 'Plaats', value: args.location.values.visitcity, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.region = new _TextControl2.default(fieldsetAddress, { label: 'Provincie', value: args.location.values.visitregion, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.country = new _SelectControl2.default(fieldsetAddress, { label: 'Land', value: args.location.values.visitcountry, options: _CountryOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
    this.addressGoogleMaps = new _GoogleMapsButtonControl2.default(fieldsetAddress, { getValues: function getValues() {
        return [_this.address.getValue(), _this.zipcode.getValue(), _this.city.getValue(), _this.region.getValue(), _this.country.getValue()];
      } });

    var fragment = document.createDocumentFragment();
    fragment.appendChild(fieldsetLocation);
    fragment.appendChild(fieldsetContact);
    fragment.appendChild(fieldsetPost);
    fragment.appendChild(fieldsetAddress);

    element.appendChild(fragment);
  }

  _createClass(LocationForm, [{
    key: 'getValue',
    value: function getValue() {
      var location = new _LocationModel2.default();
      location.organisation = this.organisation.getItem();
      location.values.id = this.id;
      location.values.organisation_id = this.organisation.getValue();
      location.values.business = this.business.getValue();
      location.values.postaddress = this.postaddress.getValue();
      location.values.postzipcode = this.postzipcode.getValue();
      location.values.postcity = this.postcity.getValue();
      location.values.postregion = this.postregion.getValue();
      location.values.postcountry = this.postcountry.getValue();
      location.values.phone = this.phone.getValue();
      location.values.email = this.email.getValue();
      location.values.fax = this.fax.getValue();
      location.values.website = this.website.getValue();
      location.values.visitaddress = this.address.getValue();
      location.values.visitzipcode = this.zipcode.getValue();
      location.values.visitcity = this.city.getValue();
      location.values.visitregion = this.region.getValue();
      location.values.visitcountry = this.country.getValue();
      return location;
    }
  }, {
    key: 'setValue',
    value: function setValue(location) {
      this.id = location.values.id;
      this.organisation.setValue(location.values.organisation_id, location.organisation);
      this.business.setValue(location.values.business);
      this.postaddress.setValue(location.values.postaddress);
      this.postzipcode.setValue(location.values.postzipcode);
      this.postcity.setValue(location.values.postcity);
      this.postregion.setValue(location.values.postregion);
      this.postcountry.setValue(location.values.postcountry);
      this.phone.setValue(location.values.phone);
      this.email.setValue(location.values.email);
      this.fax.setValue(location.values.fax);
      this.website.setValue(location.values.website);
      this.address.setValue(location.values.visitaddress);
      this.zipcode.setValue(location.values.visitzipcode);
      this.city.setValue(location.values.visitcity);
      this.region.setValue(location.values.visitregion);
      this.country.setValue(location.values.visitcountry);
    }
  }]);

  return LocationForm;
}();

exports.default = LocationForm;


//////////////////
// WEBPACK FOOTER
// ./js/modules/location/ui/LocationForm.js
// module id = 63
// module chunks = 0